import styled from "styled-components";

export const SummaryBarStyled = styled.div`
    width: 100%;
    margin-top: 25px;
`;

export const Info = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;
